import { render, staticRenderFns } from "./Reg2.vue?vue&type=template&id=77438205&scoped=true&"
import script from "./Reg2.vue?vue&type=script&lang=js&"
export * from "./Reg2.vue?vue&type=script&lang=js&"
import style0 from "./Reg2.vue?vue&type=style&index=0&id=77438205&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77438205",
  null
  
)

export default component.exports